import React, {Component} from "react";
import {bindActionCreators} from "redux";
import {withRouter, NavLink} from "react-router-dom";
import {connect} from "react-redux";
import {Form, Input, Button, Select, message, Spin, Checkbox, Radio} from "antd";
import CloudFlyerAPI from "../../../api/CloudFlyerAPI";
import {receiveError} from "../../../api/http";
import {Row, Col, Tooltip as Toltip, Popover} from 'antd';

// import CreateReport from '../EachAccount/eachaccount';

// import wasabiDarkLogo from "../../../assets/logo/wasabi_header_logo_dark.png";
import wasabiDarkLogo from "../../../assets/logo/amove-dark-logo.svg";
import arrowLeft from "../../../assets/img/icon/arrow-left-icon.svg";

import "./addNewSubscription.scss";
import queryString from "query-string";

class AddNewSubscription extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            formValid: false,
            accountList: [],
            selectedAccount: null,
            userID: "",
            username: "",
            selectedUserType: null,
            selectedOption: 1, // Default to Product Package
            packages: [], // Holds product packages
            features: [], // Holds product features
        };
    }

    componentDidMount() {
        this.fetchAllPackages();
        this.fetchAllFeatures();
        setTimeout(() => {
            const queryParams = queryString.parse(this.props.location.search);
            this.setState({
                userID : queryParams.id,
                username : queryParams.username,
            });

        }, 1000);
    }


    handleSubmit = (e) => {
        e.preventDefault();
        console.log("submit account");
        this.setState({loading: true});
        const {userId, productPackageId, productFeatureId, paymentMethod, paymentReference, featureReference,
            SubscriptionStatus, SelectProductPackage, SelectProductFeature} = this.props.form.getFieldsValue();

        // Set the start date as the current date
        const currentStartDate = new Date().toISOString();

        // Calculate endDateSet based on selected duration
        let endDateSet = new Date(); // Start with the current date

        if (SelectProductPackage || SelectProductFeature) {
            const selectedDuration = (SelectProductPackage
                ? this.state.packages.find(pkg => pkg.id === SelectProductPackage)
                : this.state.features.find(feat => feat.id === SelectProductFeature))?.duration;

            if (selectedDuration === 1) {
                // Add 1 month to current date for duration 1
                endDateSet.setMonth(endDateSet.getMonth() + 1);
            } else if (selectedDuration === 2) {
                // Add 1 year to current date for duration 2
                endDateSet.setFullYear(endDateSet.getFullYear() + 1);
            }
        }
        var  subscriptionType = 1;
        if(this.state.selectedOption === 2){
            var features = this.state.features.filter(feat => feat.id === SelectProductFeature);
            console.log(this.state.features)
            console.log(features)
            subscriptionType = features[0]?.featureType;
        }

        console.log(subscriptionType)


        CloudFlyerAPI.admin_subscription
            .addNewSubscription({
                "userId": this.state.userID,
                "productPackageId": SelectProductPackage || null,
                "productFeatureId": SelectProductFeature || null,
                "startDate": currentStartDate,
                "endDate": endDateSet.toISOString(), // Convert to ISO string
                "subscriptionType": parseInt(subscriptionType),
                "paymentMethod": parseInt(paymentMethod),
                "paymentReference": paymentReference,
                "featureReference": featureReference,
                "status": parseInt(SubscriptionStatus),
            })
            .then(() => {
                message.success("Subscription Added Successfully!");
                this.setState({loading: false, formValid: false});
                this.props.form.resetFields(); // Reset form after success
            })
            .catch((err) => {
                message.error("Something went wrong!");
                this.setState({loading: false});
            });


    };
    checkIfFormIsFilled = () => {
        const values = this.props.form.getFieldsValue();
        const requiredFields = [
            "paymentMethod",
            "SubscriptionStatus",
            "paymentReference",
            "featureReference",
        ];

        // Ensure at least one of "SelectProductPackage" or "SelectProductFeature" is filled
        const packageOrFeatureFilled = values["SelectProductPackage"] || values["SelectProductFeature"];

        // Ensure all required fields are filled
        const allFieldsFilled = requiredFields.every(field => values[field] && values[field] !== "");

        // Form is valid if either package or feature is filled AND all other required fields are filled
        this.setState({ formValid: packageOrFeatureFilled && allFieldsFilled });
    };




    fetchAllPackages = () => {
        this.setState({ loading: true });

        CloudFlyerAPI.product_packages
            .getAllPackages(5000, 1, false)
            .then(({ data }) => {
                console.log("Packages 12:", data);
                this.setState({
                    loading: false,
                    packages: data?.data || [], // Ensure fallback to an empty array
                });
            })
            .catch((err) => {
                console.log("Packages 13:", err);
                const msg = receiveError(null, err).message;
                message.error(msg);
                this.setState({ loading: false });
            });
    };

    fetchAllFeatures = () => {
        this.setState({ loading: true });

        CloudFlyerAPI.product_features
            .getAllFeatures(5000, 1, false)
            .then(({ data }) => {
                console.log("Features 12:", data);
                this.setState({
                    loading: false,
                    features: data?.data || [], // Ensure fallback to an empty array
                });
            })
            .catch((err) => {
                const msg = receiveError(null, err).message;
                message.error(msg);
                this.setState({ loading: false });
            });
    };
    handleRadioChange = (e) => {
        this.setState({ selectedOption: e.target.value });
    };

    render() {
        const {getFieldDecorator} = this.props.form;
        const {Option} = Select;
        const {loading, formValid} = this.state;
        const { selectedOption, packages, features} = this.state;
        return (
            <div className="add-new-user-container less-margin">
                <div className="back-wrapper">
                    <NavLink to={"/subscriptionAdmin?id=" + this.state.userID + "&username=" + this.state.username}><img src={arrowLeft} alt="icon"/> Back</NavLink>
                </div>
                <div className="content-box">
                    <div className="wasabiLogo">
                        <img alt="wasabi Logo" src={wasabiDarkLogo}/>
                    </div>

                    <div className="add-user-form">
                        <Form
                            layout="horizontal"
                            onSubmit={this.handleSubmit.bind(this)}
                            className="user-form"
                        >
                            <Form.Item>
                                <Radio.Group value={selectedOption} defaultValue={1} onChange={this.handleRadioChange}>
                                    <Radio value={1}>Product Package</Radio>
                                    <Radio value={2}>Product Feature</Radio>
                                </Radio.Group>
                            </Form.Item>
                            {/* Show Product Package select when selected */}
                            {selectedOption === 1 && !loading && packages.length > 0 && (
                                <Form.Item>
                                    {getFieldDecorator("SelectProductPackage")(
                                        <Select placeholder="Select Product Package">
                                            {packages.map((pkg) => (
                                                <Option key={pkg.id} value={pkg.id}>
                                                    {pkg.name} ({pkg.duration === 1 ? "Monthly" : "Annual"})
                                                </Option>
                                            ))}
                                        </Select>
                                    )}
                                </Form.Item>
                            )}

                            {/* Show Product Feature select when selected */}
                            {selectedOption === 2 && !loading && features.length > 0 && (
                                <Form.Item>
                                    {getFieldDecorator("SelectProductFeature")(
                                        <Select placeholder="Select Product Feature" loading={loading}>
                                            {features.length > 0 ? (
                                                features.map((feature) => (
                                                    <Option key={feature.id} value={feature.id}>
                                                        {feature.name} ({feature.duration === 1 ? "Monthly" : "Annual"})
                                                    </Option>
                                                ))
                                            ) : (
                                                <Option disabled>No Features Available</Option>
                                            )}
                                        </Select>
                                    )}
                                </Form.Item>
                            )}


                            {/*<Form.Item>
                                {getFieldDecorator("subscriptionType")(
                                    <Select placeholder="Subscription Type" onChange={this.checkIfFormIsFilled}>
                                        <Option value="1">App</Option>
                                        <Option value="2">Storage</Option>
                                        <Option value="4">Admin User</Option>
                                        <Option value="8">Creative User</Option>
                                        <Option value="16">Standard User</Option>
                                        <Option value="32">Connection</Option>
                                        <Option value="64">Project</Option>
                                        <Option value="128">Team</Option>
                                        <Option value="256">Drive</Option>
                                        <Option value="512">Sync</Option>
                                        <Option value="1024">SSO</Option>
                                        <Option value="2048">Logs</Option>
                                        <Option value="4096">FreeUser</Option>
                                        <Option value="8192">FreeConnection</Option>
                                    </Select>
                                )}
                            </Form.Item>*/}

                            <Form.Item>
                                {getFieldDecorator("paymentMethod")(
                                    <Select placeholder="Payment Method" onChange={this.checkIfFormIsFilled}>
                                        <Option value="1">Stripe</Option>
                                        <Option value="2">Direct Transfer</Option>
                                    </Select>
                                )}
                            </Form.Item>

                            <Form.Item>
                                {getFieldDecorator("SubscriptionStatus")(
                                    <Select placeholder="Subscription Status" onChange={this.checkIfFormIsFilled}>
                                        <Option value="1">Pending</Option>
                                        <Option value="2">Active</Option>
                                        <Option value="4">Cancelled</Option>
                                        <Option value="8">Expired</Option>
                                    </Select>
                                )}
                            </Form.Item>

                            <Form.Item>
                                {getFieldDecorator("paymentReference")(
                                    <Input placeholder="Payment Reference" className="user-input" type="text" onChange={this.checkIfFormIsFilled}/>
                                )}
                            </Form.Item>

                            <Form.Item>
                                {getFieldDecorator("featureReference")(
                                    <Input placeholder="Feature Reference" className="user-input" type="text" onChange={this.checkIfFormIsFilled}/>
                                )}
                            </Form.Item>

                            <Form.Item>
                                <Button
                                    className="user-btn"
                                    type="primary"
                                    size="large"
                                    // loading={this.state.loading}
                                    loading={loading}
                                    htmlType="submit"
                                    // disabled={!formValid}
                                    block
                                >
                                    Add New Subscription
                                </Button>
                            </Form.Item>
                        </Form>
                    </div>
                </div>
            </div>
        );
    }
}

export default withRouter(connect()(Form.create()(AddNewSubscription)));
